var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-wrapper" }, [
    _c(
      "div",
      { staticClass: "confirmation" },
      [
        _c("card-header", {
          attrs: {
            title: "Welcome!",
            designVersion: 2,
            subtitle: "Add your info to make collaborating easy",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [
          _c(
            "div",
            { staticClass: "spinner", class: { hidden: !_vm.isSubmitting } },
            [_c("i", { staticClass: "fa fa-spinner fa-pulse" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group", class: { hidden: _vm.isSubmitting } },
            [
              _c("input-set", {
                ref: "firstName",
                attrs: {
                  type: "text",
                  name: "first-name",
                  label: _vm.errors.firstName ? _vm.errors.firstName : "",
                  placeholder: "First name*",
                  hasError: _vm.errors.firstName ? true : false,
                },
                on: {
                  inputOnEnter: _vm.signUp,
                  inputOnBlur: _vm.checkOnInputBlur,
                  inputOnType: _vm.checkOnInputType,
                },
                model: {
                  value: _vm.firstName,
                  callback: function ($$v) {
                    _vm.firstName = $$v
                  },
                  expression: "firstName",
                },
              }),
              _vm._v(" "),
              _c("input-set", {
                attrs: {
                  type: "text",
                  name: "last-name",
                  label: _vm.errors.lastName ? _vm.errors.lastName : "",
                  placeholder: "Last name*",
                  hasError: _vm.errors.lastName ? true : false,
                },
                on: {
                  inputOnEnter: _vm.signUp,
                  inputOnBlur: _vm.checkOnInputBlur,
                  inputOnType: _vm.checkOnInputType,
                },
                model: {
                  value: _vm.lastName,
                  callback: function ($$v) {
                    _vm.lastName = $$v
                  },
                  expression: "lastName",
                },
              }),
              _vm._v(" "),
              _c("input-set", {
                attrs: {
                  isDropdown: true,
                  type: "text",
                  name: "industry",
                  label: _vm.errors.industry ? _vm.errors.industry : "",
                  placeholder: "Industry*",
                  selected: _vm.industry,
                  entries: _vm.industries,
                  hasError: _vm.errors.industry ? true : false,
                },
                on: {
                  inputOnEnter: _vm.signUp,
                  inputOnBlur: _vm.checkOnInputBlur,
                  onDropdownChange: _vm.onIndustryChange,
                  inputOnFocus: _vm.onIndustryFocus,
                },
                model: {
                  value: _vm.industry,
                  callback: function ($$v) {
                    _vm.industry = $$v
                  },
                  expression: "industry",
                },
              }),
              _vm._v(" "),
              _c("input-set", {
                ref: "phoneNumber",
                attrs: {
                  type: "phone",
                  name: "phone-number",
                  label: _vm.errors.phoneNumber ? _vm.errors.phoneNumber : "",
                  placeholder: "Phone number*",
                  hasError: _vm.errors.phoneNumber ? true : false,
                },
                on: {
                  inputOnEnter: function ($event) {
                    _vm.phoneNumberInput ? _vm.signUp : () => {}
                  },
                  inputOnBlur: _vm.checkOnInputBlur,
                  inputOnType: _vm.checkOnInputType,
                },
                model: {
                  value: _vm.phoneNumberInput,
                  callback: function ($$v) {
                    _vm.phoneNumberInput = $$v
                  },
                  expression: "phoneNumberInput",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button-wrapper" },
                [
                  !_vm.isSubmitting
                    ? _c("custom-button", {
                        attrs: {
                          text: "Start using Autobahn",
                          isActive: _vm.buttonState,
                          size: "button-large",
                        },
                        on: { enter: _vm.signUp, click: _vm.signUp },
                      })
                    : _c(
                        "button",
                        {
                          staticClass: "btn btn-primary hidden",
                          attrs: {
                            id: "mock-button-to-maintain-form-height",
                            isActive: false,
                          },
                        },
                        [_vm._v("Start using Autobahn")]
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }